import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import type { StudentProfileSectionItem } from '@modules/types/graphql';

export type Entity = Partial<StudentProfileSectionItem> | null;

@DecribeEntity('StudentProfileItemEntity')
class StudentProfileItemEntity extends BaseEntity {
    label: string;
    link: string;
    value: string;

    constructor(profileItem: Entity) {
        super(profileItem);

        this.label = profileItem?.label ?? '';
        this.link = profileItem?.link ?? '';
        this.value = profileItem?.value ?? '';
    }

    getLabel() {
        if (this.label === 'divider') {
            return '';
        }

        return this.label;
    }

    getValue() {
        if (this.label === 'divider') {
            return '';
        }

        return this.getFieldOrDefaultValue('value');
    }
}

export { StudentProfileItemEntity };
